export default __webpack_public_path__ + "static/cake-d40fd49b7e79bccf24b422de8f53423b.png";